<nav class="navbar navbar-expand-lg navbar-light bg-light">
<!--  <div class="button-row">-->
    <button class="m-1 mr-2" mat-raised-button routerLink="../..">
      <mat-icon>arrow_back</mat-icon> Inspections & Audits
    </button>

    <button class="m-1 mr-2" mat-raised-button routerLink="/audits/{{ audit.id }}/view"
      *ngIf="audit?.id">
      <mat-icon>remove_red_eye</mat-icon>
      View
    </button>

    <button class="m-1 mr-2" mat-raised-button (click)="delete(audit)" *ngIf="audit?.id && canDelete">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
<!--  </div>-->
</nav>

<div class="app-padding">
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h6>Inspection/Audit</h6>
      </div>

      <form #form="ngForm" (ngSubmit)="onSubmit()" class="card-body">
        <mat-form-field class="m-1 py-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Inspection/Audit</mat-label>
          <input matInput placeholder="Inspection/Audit" [(ngModel)]="audit.name"
            name="name" type="text" required #name />
          <mat-error *ngIf="!name.valid">Please enter an Inspection/Audit name.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="m-1 py-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Positive Comments</mat-label>
          <input matInput placeholder="Positive Comments"
            [(ngModel)]="audit.positive_comments" name="positive_comments"
            type="text" />
        </mat-form-field>

        <button
          mat-raised-button
          [disabled]="!form.valid || inProgress"
          color="primary"
          (click)="onSubmit()"
          class="my-2 ml-1 mr-2"
          type="button">
          <mat-icon>save</mat-icon>
          Save
        </button>

        <button
          mat-raised-button
          color="secondary"
          id="contractors-button"
          [matBadge]="'' + audit.contractor_ids?.length"
          type="button"
          (click)="onSelectContractors()"
          class="my-2 ml-1 mr-2">
          <fa-icon [icon]="faHardHat"></fa-icon>
          Associate {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
        </button>

<!--        Hidden until this feature is expanded in a future phase -->
<!--        <button-->
<!--          mat-raised-button-->
<!--          class="my-2 ml-1 mr-2"-->
<!--          type="button"-->
<!--          color="secondary"-->
<!--          id="assets_selector_button"-->
<!--          (click)="onSelectAssets()"-->
<!--          [matBadge]="'' + audit?.asset_ids?.length">-->
<!--          <mat-icon>forklift</mat-icon>-->
<!--          Associate Assets-->
<!--        </button>-->
      </form>
    </div>
  </div>
</div>
